import type { TabProps } from '@material-ui/core';
import type { FC } from 'react';
import React, { memo } from 'react';

import * as Styled from './styles';

export const Tab: FC<TabProps> = memo((props) => <Styled.BaseTab {...props} />);